import React from "react";
import Vmarine from "../img/Vmarine.jpg";
import aguaDeLuz from "../img/aguaDeLuz.png";
import todo from "../img/todolist.png";
import PropTypes from "prop-types";

export default class Projects extends React.Component {

	render() {
		return (
			<React.Fragment>
				<div id="my-projects" className="container-fluid bg-light mt-5">
					<div className=" project-container container bg-light pb-5">
						<h1
							id="projects"
							className={"text-center " + this.props.fadeInRight}>
							Projects
						</h1>
						<div className="row my-5">
							<div
								className={
									"testbg col-12 col-sm-12 col-md-4 " +
									this.props.fadeIn
								}>
								<div className="overlay">
									<div className="text">
										<h2>Groww.in</h2>
									</div>
									<div>
										<button
											id="vmarine-button"
											className="project-button"
											onClick={() => {
												var modalBG = document.getElementById(
													"gallery-card"
												);
												var marineModal = document.getElementById(
													"vmarine"
												);
												modalBG.style.display = "block";
												marineModal.style.display =
													"block";
											}}>
											More details
										</button>
									</div>
								</div>
							</div>
							<div
								className={
									"aguabg col-12 col-sm-12 col-md-4 " +
									this.props.fadeIn
								}>
								<div className="overlay">
									<div className="text">
										<h2>Banggood.com</h2>
									</div>
									<div>
										<button
											id="agua-button"
											className="project-button"
											onClick={() => {
												var modalBG = document.getElementById(
													"gallery-card"
												);
												var aguaModal = document.getElementById(
													"agualuz"
												);
												modalBG.style.display = "block";
												aguaModal.style.display =
													"block";
											}}>
											More details
										</button>
									</div>
								</div>
							</div>
							<div
								className={
									"todobg col-12 col-sm-12 col-md-4 " +
									this.props.fadeIn
								}>
								<div className="overlay">
									<div className="text">
										<h2>Asos.com</h2>
									</div>
									<div>
										<button
											id="todo-button"
											className="project-button"
											onClick={() => {
												var modalBG = document.getElementById(
													"gallery-card"
												);
												var todoModal = document.getElementById(
													"todolist"
												);
												modalBG.style.display = "block";
												todoModal.style.display =
													"block";
											}}>
											More details
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				{/*hidden modals*/}
				<div id="gallery-card">
					<div id="vmarine" className="modal-card">
						


						<div className="modal-info">
						<p
						className="close-icon"
						style={{
							textAlign: "right",
							fontWeight: 800,
							fontSize: 1 + "rem",
							cursor: "pointer",
							marginTop: "0px",
							paddingTop:"0px",
							display:"inline-block",
							marginTop:"0"
						}}
						onClick={() => {
							var modalBG = document.getElementById(
								"gallery-card"
							);
							var marineModal = document.getElementById(
								"vmarine"
							);
							modalBG.style.display = "none";
							marineModal.style.display = "none";
						}}>
						&#10005;
					</p>
							
							<div className="modal-description">
							<img  style={{width: "480px" , 
							  margin: 'auto',  
							  display: "block",
                              marginLeft: "auto",
                              marginRight: "auto",
                              width: "95%",
							
							}} src="https://github.com/Shubham007-tech/Groww_website_Clone/blob/main/Groww%20Clone%20Screenshots/Groww%20Product%20Description.png?raw=true"></img>
                          <br></br>								


							<p style={{
								fontSize:'13px',
								marginLeft: "auto",
								marginRight: "auto",
								width: "95%",
								
						  
						  }}> 
						       Groww is an investing platform where users can find the best mutual funds
									 to invest in and can invest their money without any hassles.
									 A joint effort project with Attractive Homepage 
                                   , Mutual funds product with sorting and filter ,
                                    Product detail with chart and interest calculator.
									Designed with HTML5, CSS3, Javascript,
										Node and Chart.js.
						 
						  </p>
							
							<br></br>
							
							</div>
							<div className="modal-bottom">
								

								<a
								href="https://shubham007-tech.github.io/Groww_website_Clone/"
								target="_blank"
								>
								
							
								<button className="buttondep">Deployed link</button>
							</a>

							<a
								href="https://drive.google.com/file/d/1RnNlT4aQPL0bPNjDo9zBMTFFumwqtcIM/view?usp=sharing"
								target="_blank"
								>
								
								<button className="buttondep ">Video Demo</button>
							</a>

							<a
								href="https://github.com/Shubham007-tech/Groww_website_Clone"
								target="_blank"
								>
								
								<button className="buttondep">Github Code</button>
							</a>


								
							</div>
						</div>
					</div>

					<div id="agualuz" className="modal-card">
						<div className="visual">
							
						</div>

						
						<div className="modal-info">
						<p
									className="close-icon"
									style={{
										textAlign: "right",
										fontWeight: 800,
										fontSize: 1 + "rem",
										cursor: "pointer",
										marginTop: "0px",
										paddingTop:"0px",
										display:"inline-block",
										marginTop:"0"
									}}
									onClick={() => {
										var modalBG = document.getElementById(
											"gallery-card"
										);
										var aguaModal = document.getElementById(
											"agualuz"
										);
										modalBG.style.display = "none";
										aguaModal.style.display = "none";
									}}>
									&#10005;
								</p>
							
							<div className="modal-description">
							<img style={{width: "480px" , 
							margin: 'auto',  
							display: "block",
							marginLeft: "auto",
							marginRight: "auto",
							width: "93%",
							
						  
						  }} src="https://github.com/Shubham007-tech/Clone-Banggood.com/raw/main/Images/MensProducts.png"></img>
						  <br></br>
						 
						  <p style={{
							  fontSize:'13px',
							  marginLeft: "auto",
							  marginRight: "auto",
							  width: "93%",
							  
						
						}}>A shopping website with a wide variety
						  of lifestyle products.
						  A Solo project with key feature like - SignIn|SignUp with Api authentication,
						  User centered design and categorize option 
						  Developed with HTML5, CSS3, Javascript( es6 ) ,
						  Node, heroku. </p>

						  <br></br>
							</div>
							<div className="modal-bottom">
								

							<a
							href="https://shubham007-tech.github.io/Clone-Banggood.com/"
							target="_blank"
							>
							<button className="buttondep">Deployed link</button>
						</a>

						<a
							href="https://drive.google.com/file/d/1hW12cCFCmTJ2fwk7p7MD6mmiS0FnNYFy/view?usp=sharing"
							target="_blank"
							>
							<button className="buttondep">Video Demo</button>
						</a>

						<a
							href="https://github.com/Shubham007-tech/Clone-Banggood.com"
							target="_blank"
							>
							<button className="buttondep">Github Code</button>
						</a>


								
							</div>
						</div>
					</div>

					<div id="todolist" className="modal-card">
						<div className="visual">
							
						</div>


						<div className="modal-info">
						<p
						className="close-icon"
						style={{
							textAlign: "right",
							fontWeight: 800,
							fontSize: 1 + "rem",
							cursor: "pointer",
							marginTop: "0px",
							paddingTop:"0px",
							display:"inline-block",
							marginTop:"0"
						}}
						onClick={() => {
							var modalBG = document.getElementById(
								"gallery-card"
							);
							var todoModal = document.getElementById(
								"todolist"
							);
							modalBG.style.display = "none";
							todoModal.style.display = "none";
						}}>
						&#10005;
					</p>
							
							<div className="modal-description">
							<img style={{width: "380px" , 
							margin: 'auto',  
							display: "block",
							marginLeft: "auto",
							marginRight: "auto",
							width: "94%",
						  
						  }} src="https://www.venturef0rth.com/wp-content/uploads/2020/06/asos.jpg"></img>
								<p style={{
									fontSize:'13px',
									marginLeft: "auto",
									marginRight: "auto",
									width: "94%",
									
							  
							  }}>
							  <br></br>
							  ASOS.com is a British online fashion
										shopping website with wide variety of clothing products and cosmetics.
									A Collaborative project with team of three made this project under 4 days.
										Developed with HTML5, CSS3, Javascript.
								</p>
							</div>
							<br></br>
							<div className="modal-bottom">
								
							<a
							href="https://shubham007-tech.github.io/Clone_Asos/"
							target="_blank"
							>
							<button className="buttondep">Deployed link</button>
						</a>

						<a
							href="https://drive.google.com/file/d/1rDM2nuFNr6UDlTuU_leOksZtYcHScT8_/view?usp=sharing"
							target="_blank"
							>
							<button className="buttondep">Video Demo</button>
						</a>

						<a
							href="https://github.com/Shubham007-tech/Clone_Asos"
							target="_blank"
							>
							<button className="buttondep ">Github Code</button> 
						</a>
                              




							
							</div>
						</div>
					</div>
				</div>
			</React.Fragment>
		);
	}
}

Projects.propTypes = {
	bounceIn: PropTypes.string,
	fadeInLeft: PropTypes.string,
	fadeInRight: PropTypes.string,
	fadeIn: PropTypes.string,
	tada: PropTypes.string
};
